module.exports = __webpack_public_path__ + "img/prototype.34f52d99.svg";